module.exports = __webpack_public_path__ + "producr-dried fresh-grass-10.jpg?fee0c7f5ec7ceb45aa010874c382e3a0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/producr-dried fresh-grass-10.jpg
// module id = 68
// module chunks = 0